import LocationActions from 'actions/Location'
import SectorActions from 'actions/Sector'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import { LocationAction, LocationSector } from 'types/location'
import { SectorAction, SectorReducer } from 'types/sector'
import UserServices from 'services/User'
import { IUserWithLocation } from 'types/user'
import { GroupTreatmentModal } from 'components/Modals/GroupTreatment'
import { GroupAssumeTreatmentModal } from 'components/Modals/GroupAssumeTreatment'
import { GroupRemoveNotificationsModal } from 'components/Modals/GroupRemoveNotifications'
import { GroupUndoTreatmentModal } from 'components/Modals/GroupUndoTreatment'
import { GroupMoreInfoModal } from 'components/Modals/GroupMoreInfo'
import { GroupTreatmentFailureModal } from 'components/Modals/GroupTreatmentFailure'

export const Page = () => {
    const [isGroupTreatmentModalOpen, setIsGroupTreatmentModalOpen] = useState(false)
    const [isGroupAssumeTreatmentModalOpen, setIsGroupAssumeTreatmentModalOpen] = useState(false)
    const [isGroupRemoveNotificationsModalOpen, setIsGroupRemoveNotificationsModalOpen] = useState(false)
    const [isGroupUndoTreatmentModalOpen, setIsGroupUndoTreatmentModalOpen] = useState(false)
    const [isGroupMoreInfoModalOpen, setIsGroupMoreInfoModalOpen] = useState(false)
    const [isGroupTreatmentFailureModalOpen, setIsGroupTreatmentFailureModalOpen] = useState(false)
    const [isGroupTreatmentFailurePartialModalOpen, setIsGroupTreatmentFailurePartialModalOpen] = useState(false)
    const [groupCount, setGroupCount] = useState(5)
    const [protocolCount, setProtocolCount] = useState(5)
    const [treatmentStatus, setTreatmentStatus] = useState<'started' | 'not_started'>('not_started')
    const [notificationStatus, setNotificationStatus] = useState<string>('2') // '2' = Aguardando, '3' = Em Tratamento
    const [failedNotifications, setFailedNotifications] = useState<any[]>([])
    
    const sectorSelector: SectorReducer = useSelector(
        (state: RootReducerState) => state.sectorReducers
    )
    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const locationDispatch = useDispatch()
    const sectorDispatch = useDispatch()

    useEffect(() => {
        if (auth?.dataJwt && !auth?.isAutheticated) {
            LocationActions.getAllLocations(locationDispatch)
            SectorActions.getAllSectors(sectorDispatch)
            SectorActions.getAllSectorsGroupedByLocationsId(sectorDispatch)

        }
    }, [auth?.dataJwt])

    const handleOpenGroupTreatmentModal = () => {
        setIsGroupTreatmentModalOpen(true)
    }

    const handleCloseGroupTreatmentModal = () => {
        setIsGroupTreatmentModalOpen(false)
    }

    const handleIndividualTreatment = () => {
        console.log('Tratar individualmente clicado!')
        alert('Função de tratamento individual executada!')
        setIsGroupTreatmentModalOpen(false)
    }

    const handleGroupTreatment = () => {
        console.log('Seguir com o tratamento em grupo clicado!')
        setIsGroupTreatmentModalOpen(false)
        setIsGroupAssumeTreatmentModalOpen(true)
    }

    const handleCloseGroupAssumeTreatmentModal = () => {
        setIsGroupAssumeTreatmentModalOpen(false)
    }

    const handleAssumeTreatment = () => {
        console.log('Assumir tratamento em grupo clicado!')
        alert('Função de assumir tratamento em grupo executada!')
        setIsGroupAssumeTreatmentModalOpen(false)
    }

    const handleOpenGroupRemoveNotificationsModal = (status: 'started' | 'not_started') => {
        setTreatmentStatus(status)
        setIsGroupRemoveNotificationsModalOpen(true)
    }

    const handleCloseGroupRemoveNotificationsModal = () => {
        setIsGroupRemoveNotificationsModalOpen(false)
    }

    const handleConfirmGroupRemoveNotifications = () => {
        console.log('Removendo notificações do grupo...')
        alert(`Função de remoção executada! Status: ${treatmentStatus}`)
        setIsGroupRemoveNotificationsModalOpen(false)
    }

    const handleOpenGroupUndoTreatmentModal = (status: 'started' | 'not_started') => {
        setTreatmentStatus(status)
        setIsGroupUndoTreatmentModalOpen(true)
    }

    const handleCloseGroupUndoTreatmentModal = () => {
        setIsGroupUndoTreatmentModalOpen(false)
    }

    const handleConfirmGroupUndoTreatment = () => {
        console.log('Desfazendo tratamento em grupo...')
        alert(`Função de desfazer tratamento executada! Status: ${treatmentStatus}`)
        setIsGroupUndoTreatmentModalOpen(false)
    }

    const handleOpenGroupMoreInfoModal = () => {
        setIsGroupMoreInfoModalOpen(true)
    }

    const handleCloseGroupMoreInfoModal = () => {
        setIsGroupMoreInfoModalOpen(false)
    }

    const handleOpenGroupTreatmentFailureModal = (status: string) => {
        setNotificationStatus(status)
        setIsGroupTreatmentFailureModalOpen(true)
    }

    const handleCloseGroupTreatmentFailureModal = () => {
        setIsGroupTreatmentFailureModalOpen(false)
    }

    const generateFakeProtocols = (count: number) => {
        const protocols = []
        for (let i = 1; i <= count; i++) {
            const protocolNumber = `2024${String(i).padStart(4, '0')}`
            protocols.push({
                sys_id: { value: `fake-${i}`, display_value: `fake-${i}` },
                number: { value: protocolNumber, display_value: protocolNumber },
                incident_title: { value: `Incidente Fictício ${i}`, display_value: `Incidente Fictício ${i}` },
                incident_description: { value: `Descrição fictícia do incidente ${i}`, display_value: `Descrição fictícia do incidente ${i}` },
                sys_created_on: { value: new Date().toISOString(), display_value: new Date().toLocaleDateString() }
            })
        }
        return protocols
    }

    const handleOpenGroupTreatmentFailurePartialModal = (status: string = '2') => {
        const fakeNotifications = generateFakeProtocols(protocolCount)
        setFailedNotifications(fakeNotifications)
        setNotificationStatus(status)
        setIsGroupTreatmentFailurePartialModalOpen(true)
    }

    const handleCloseGroupTreatmentFailurePartialModal = () => {
        setIsGroupTreatmentFailurePartialModalOpen(false)
    }

    // Funções específicas para os botões de teste
    const handleOpenGroupTreatmentFailurePartialAguardando = () => handleOpenGroupTreatmentFailurePartialModal('2')
    const handleOpenGroupTreatmentFailurePartialEmTratamento = () => handleOpenGroupTreatmentFailurePartialModal('3')

    const createAndInactivateSectors = () => {
        let sem_barra_no_nome = sectorSelector?.sectorsGroupedByLocationId[barra_dor]?.filter(o => !(o?.u_name.includes('BARRA') || o?.u_name.includes('Barra')))
        console.log(sem_barra_no_nome, sectorSelector?.sectorsGroupedByLocationId[barra_dor])
        if (sem_barra_no_nome?.length > 0) {
            if (sem_barra_no_nome?.length > 0) {
                sem_barra_no_nome.forEach(async o => {
                    console.log(o?.u_name)
                    console.log("cria")
                    // await SectionService.createNewSector({ u_name: 'BARRA I - ' + o.u_name })
                    console.log("inativa")
                    // let locationSector: LocationSector = {
                    //     u_active: {
                    //         value: 'false',
                    //         display_value: 'Falso'
                    //     },
                    //     x_rdsls_notificabe_locations: {
                    //         value: barra_dor,
                    //         display_value: "RJ - Barra D'OR"
                    //     },
                    //     x_rdsls_notificabe_sectors: {
                    //         value: o?.sys_id,
                    //         display_value: o?.u_name
                    //     },
                    //     isLoading: true
                    // }
                    // LocationActions.updateLocationStatusCache(locationDispatch, locationSector)
                })
            }
        }
    }

    const updateNewSectors = () => {
        let com_barra_1_no_nome = sectorSelector?.sectorsList?.filter(o => o?.u_name.includes('BARRA I') && o?.u_count_active == "0")
        if (com_barra_1_no_nome?.length > 0) {
            com_barra_1_no_nome.forEach(async o => {
                console.log(o?.u_name, com_barra_1_no_nome)
                console.log("só ativa")
                // let locationSector: LocationSector = {
                //     u_active: {
                //         value: 'true',
                //         display_value: 'Verdadeiro'
                //     },
                //     x_rdsls_notificabe_locations: {
                //         value: barra_dor,
                //         display_value: "RJ - Barra D'OR"
                //     },
                //     x_rdsls_notificabe_sectors: {
                //         value: o?.sys_id,
                //         display_value: o?.u_name
                //     },
                //     isLoading: true
                // }
                // LocationActions.updateLocationStatusCache(locationDispatch, locationSector)
            })
        }
    }

    const updateUsers = (user: any, treatedLocations: {
        sys_id: string
        sectors: {
            sys_id: string
        }[]
    }[]) => {
        const targetUser: IUserWithLocation = {
            u_user: user?.u_user,
            u_profile: user?.u_profile,
            u_locations: treatedLocations,
            u_active: user?.u_active === 1 ? 'true' : 'false'
        }
        UserServices.updateUserBySysIdResource(targetUser, user?.sys_id)
    }

    const barra_dor = 'df5ab5fe1bfa7810bcd687bfe54bcb2d'

    useEffect(() => {
        createAndInactivateSectors()
    }, [sectorSelector?.sectorsGroupedByLocationId])

    useEffect(() => {
        updateNewSectors()
    }, [sectorSelector?.sectorsList])

    return (
        <div className="p-8">
            <h1 className="text-2xl font-bold mb-4">Página de Desenvolvimento</h1>
            
            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste dos Modais de Grupo</h2>
                
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2">
                        Número de notificações no grupo:
                    </label>
                    <input
                        type="number"
                        value={groupCount}
                        onChange={(e) => setGroupCount(Number(e.target.value))}
                        className="border border-gray-300 rounded px-3 py-2 w-32"
                        min="1"
                        max="99"
                    />
                </div>
                
                <button
                    onClick={handleOpenGroupTreatmentModal}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 mr-2"
                >
                    Abrir Modal GroupTreatment
                </button>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste do Modal de Remoção de Notificações</h2>
                
                <button
                    onClick={() => handleOpenGroupRemoveNotificationsModal('not_started')}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 mr-2"
                >
                    Abrir Modal - Remover tratamento NÃO iniciado
                </button>
                
                <button
                    onClick={() => handleOpenGroupRemoveNotificationsModal('started')}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 mr-2"
                >
                    Abrir Modal - Remover tratamento iniciado
                </button>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste do Modal de Desfazer Tratamento</h2>
                
                <button
                    onClick={() => handleOpenGroupUndoTreatmentModal('not_started')}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 mr-2"
                >
                    Abrir Modal - Desfazer tratamento NÃO iniciado
                </button>
                
                <button
                    onClick={() => handleOpenGroupUndoTreatmentModal('started')}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 mr-2"
                >
                    Abrir Modal - Desfazer tratamento iniciado
                </button>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste do Modal de Informações</h2>
                
                <button
                    onClick={handleOpenGroupMoreInfoModal}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 mr-2"
                >
                    Abrir Modal GroupMoreInfo
                </button>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste do Modal de Falha de Agrupamento (Total)</h2>
                
                <button
                    onClick={() => handleOpenGroupTreatmentFailureModal('2')}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-600 mr-2"
                >
                    Abrir Modal - Status: Aguardando
                </button>
                
                <button
                    onClick={() => handleOpenGroupTreatmentFailureModal('3')}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 mr-2"
                >
                    Abrir Modal - Status: Em Tratamento
                </button>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-2">Teste do Modal de Falha de Agrupamento (Parcial)</h2>
                
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Número de protocolos a exibir:
                    </label>
                    <input
                        type="number"
                        min="1"
                        max="50"
                        value={protocolCount}
                        onChange={(e) => setProtocolCount(parseInt(e.target.value) || 1)}
                        className="border border-gray-300 rounded-md px-3 py-2 w-32"
                    />
                </div>
                
                <button
                    onClick={handleOpenGroupTreatmentFailurePartialAguardando}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 mr-2"
                >
                    Falha Parcial - Status: Aguardando ({protocolCount} protocolos)
                </button>
                
                <button
                    onClick={handleOpenGroupTreatmentFailurePartialEmTratamento}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 mr-2"
                >
                    Falha Parcial - Status: Em Tratamento ({protocolCount} protocolos)
                </button>
            </div>

            <GroupTreatmentModal
                isOpen={isGroupTreatmentModalOpen}
                handleCloseModal={handleCloseGroupTreatmentModal}
                handleIndividualTreatment={handleIndividualTreatment}
                handleGroupTreatment={handleGroupTreatment}
                groupCount={groupCount}
            />

            <GroupAssumeTreatmentModal
                isOpen={isGroupAssumeTreatmentModalOpen}
                handleCloseModal={handleCloseGroupAssumeTreatmentModal}
                handleAssumeTreatment={handleAssumeTreatment}
            />

            <GroupRemoveNotificationsModal
                isOpen={isGroupRemoveNotificationsModalOpen}
                handleCloseModal={handleCloseGroupRemoveNotificationsModal}
                handleConfirmRemoval={handleConfirmGroupRemoveNotifications}
                treatmentStatus={treatmentStatus}
                selectedCount={groupCount}
            />

            <GroupUndoTreatmentModal
                isOpen={isGroupUndoTreatmentModalOpen}
                handleCloseModal={handleCloseGroupUndoTreatmentModal}
                handleConfirmUndo={handleConfirmGroupUndoTreatment}
                treatmentStatus={treatmentStatus}
                selectedCount={groupCount}
            />

            <GroupMoreInfoModal
                isOpen={isGroupMoreInfoModalOpen}
                handleCloseModal={handleCloseGroupMoreInfoModal}
            />

            <GroupTreatmentFailureModal
                isOpen={isGroupTreatmentFailureModalOpen}
                handleCloseModal={handleCloseGroupTreatmentFailureModal}
                notificationStatus={notificationStatus}
                failureType="total"
            />

            <GroupTreatmentFailureModal
                isOpen={isGroupTreatmentFailurePartialModalOpen}
                handleCloseModal={handleCloseGroupTreatmentFailurePartialModal}
                notificationStatus={notificationStatus}
                failureType="partial"
                affectedCount={failedNotifications.length}
                failedNotifications={failedNotifications}
            />
        </div>
    )
}

export default Page